import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, options } from '@apexdesigner/schema-tools';

export const organization = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().describe('Name'),

    type: options([
      { value: 'Public', name: 'Public' },
      { value: 'Private', name: 'Private' },
      { value: 'Charter', name: 'Charter' },
      { value: 'N/A', name: 'N/A' },
    ])
      .nullable()
      .optional()
      .describe('Type'),

    website: z.string().nullable().optional().describe('Website'),

    fromGrade: options([
      { value: 'Kindergarten', name: 'Kindergarten' },
      { value: '1', name: '1' },
      { value: '2', name: '2' },
      { value: '3', name: '3' },
      { value: '4', name: '4' },
      { value: '5', name: '5' },
      { value: '6', name: '6' },
      { value: '7', name: '7' },
      { value: '8', name: '8' },
      { value: '9', name: '9' },
      { value: '10', name: '10' },
      { value: '11', name: '11' },
      { value: '12', name: '12' },
      { value: 'Adult', name: 'Adult' },
    ])
      .nullable()
      .optional()
      .describe('From Grade'),

    toGrade: options([
      { value: 'Kindergarten', name: 'Kindergarten' },
      { value: '1', name: '1' },
      { value: '2', name: '2' },
      { value: '3', name: '3' },
      { value: '4', name: '4' },
      { value: '5', name: '5' },
      { value: '6', name: '6' },
      { value: '7', name: '7' },
      { value: '8', name: '8' },
      { value: '9', name: '9' },
      { value: '10', name: '10' },
      { value: '11', name: '11' },
      { value: '12', name: '12' },
      { value: 'Adult', name: 'Adult' },
    ])
      .nullable()
      .optional()
      .describe('To Grade'),

    phone: z.string().nullable().optional().describe('Phone'),

    streetAddress: z.string().nullable().optional().describe('Street Address'),

    city: z.string().nullable().optional().describe('City'),

    state: options([
      { value: 'AL', name: 'Alabama' },
      { value: 'AK', name: 'Alaska' },
      { value: 'AZ', name: 'Arizona' },
      { value: 'AR', name: 'Arkansas' },
      { value: 'CA', name: 'California' },
      { value: 'CO', name: 'Colorado' },
      { value: 'CT', name: 'Connecticut' },
      { value: 'DE', name: 'Delaware' },
      { value: 'FL', name: 'Florida' },
      { value: 'GA', name: 'Georgia' },
      { value: 'HI', name: 'Hawaii' },
      { value: 'ID', name: 'Idaho' },
      { value: 'IL', name: 'Illinois' },
      { value: 'IN', name: 'Indiana' },
      { value: 'IA', name: 'Iowa' },
      { value: 'KS', name: 'Kansas' },
      { value: 'KY', name: 'Kentucky' },
      { value: 'LA', name: 'Louisiana' },
      { value: 'ME', name: 'Maine' },
      { value: 'MD', name: 'Maryland' },
      { value: 'MA', name: 'Massachusetts' },
      { value: 'MI', name: 'Michigan' },
      { value: 'MN', name: 'Minnesota' },
      { value: 'MS', name: 'Mississippi' },
      { value: 'MO', name: 'Missouri' },
      { value: 'MT', name: 'Montana' },
      { value: 'NE', name: 'Nebraska' },
      { value: 'NV', name: 'Nevada' },
      { value: 'NH', name: 'New Hampshire' },
      { value: 'NJ', name: 'New Jersey' },
      { value: 'NM', name: 'New Mexico' },
      { value: 'NY', name: 'New York' },
      { value: 'NC', name: 'North Carolina' },
      { value: 'ND', name: 'North Dakota' },
      { value: 'OH', name: 'Ohio' },
      { value: 'OK', name: 'Oklahoma' },
      { value: 'OR', name: 'Oregon' },
      { value: 'PA', name: 'Pennsylvania' },
      { value: 'RI', name: 'Rhode Island' },
      { value: 'SC', name: 'South Carolina' },
      { value: 'SD', name: 'South Dakota' },
      { value: 'TN', name: 'Tennessee' },
      { value: 'TX', name: 'Texas' },
      { value: 'UT', name: 'Utah' },
      { value: 'VT', name: 'Vermont' },
      { value: 'VA', name: 'Virginia' },
      { value: 'WA', name: 'Washington' },
      { value: 'WV', name: 'West Virginia' },
      { value: 'WI', name: 'Wisconsin' },
      { value: 'WY', name: 'Wyoming' },
      { value: 'DC', name: 'District of Columbia' },
      { value: 'AS', name: 'American Samoa' },
      { value: 'GU', name: 'Guam' },
      { value: 'MP', name: 'Northern Mariana Islands' },
      { value: 'PR', name: 'Puerto Rico' },
      { value: 'VI', name: 'U.S. Virgin Islands' },
    ])
      .nullable()
      .optional()
      .describe('State'),

    zip: z.string().nullable().optional().describe('Zip'),

    county: z.string().nullable().optional().describe('County'),

    organizationPropertyValues: hasMany('OrganizationPropertyValue'),

    students: hasMany('Student'),

    terms: hasMany('Term'),
  })
  .describe('A school or site whose students receive tutoring.')
  .as('Organization');

export { organization as organizationSchema };
